const CONSENT_STORAGE_KEY = 'cookieConsent'


const DEFAULT_CONSENT = {
	essential: true,
	marketing: false,
	consentGiven: false,
	timeStamp: null,
}

export const getConsent = () => {
	if (typeof window === 'undefined') return null

	try {
		const stored = localStorage.getItem(CONSENT_STORAGE_KEY)
		if (!stored) return null
		return JSON.parse(stored)
	} catch (error) {
		console.error('Error reading consent from localStorage:', error)
		return null
	}
}

export const setConsent = (consent) => {
	if (typeof window === 'undefined') return

	try {
		const consentToSave = {
			...DEFAULT_CONSENT,
			...consent,
			essential: true, // Always ensure essential is true
			timeStamp: consent.timeStamp || new Date().toISOString(),
		}
		localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(consentToSave))
	} catch (error) {
		console.error('Error saving consent to localStorage:', error)
	}
}

export const hasConsent = (category) => {
	if (category === 'essential') return true // Essential is always allowed

	const consent = getConsent()
	if (!consent || !consent.consentGiven) return false

	return consent[category] === true
}

export const hasGivenConsent = () => {
	const consent = getConsent()
	return consent !== null && consent.consentGiven === true
}

export const clearConsent = () => {
	if (typeof window === 'undefined') return

	try {
		localStorage.removeItem(CONSENT_STORAGE_KEY)
	} catch (error) {
		console.error('Error clearing consent from localStorage:', error)
	}
}

